import { useQuery } from '@tanstack/react-query'
import { queryKeys } from '@/shared/hooks/queries/queryKeys'
import { getThreads } from '@/features/internal/patient-messaging/apis/patientMessagingApi'

// やり取りの一覧。サイドバーの一覧と IconBar の未読ドットが同じ取得を使う。
// 30 秒ごと・タブが非アクティブの間は止まる (refetchIntervalInBackground の既定 false)。
export const useThreadsQuery = (enabled: boolean) =>
  useQuery({
    queryKey: queryKeys.patientMessaging.threads(),
    queryFn: getThreads,
    enabled,
    staleTime: 30_000,
    refetchInterval: 30_000,
  })
